// extracted by mini-css-extract-plugin
module.exports = {"nav-arrows-width-px":"58","nav-arrows-padding-right-px":"3"};